import React from "react";

// Kundenstatus options shared across UploadPolicyDialog + Anträge/Policen views.
// Keep keys in sync with UploadPolicyDialog.jsx CUSTOMER_STATUS_OPTIONS.
const CUSTOMER_STATUS_MAP = {
  neukunde:        { label: "Neukunde",          color: "#2563EB" },
  bestandskunde:   { label: "Bestandskunde",     color: "#C89F50" },
  mutation:        { label: "Mutation",          color: "#7C3AED" },
  neu_in_schweiz:  { label: "Neu in der Schweiz", color: "#10B981" },
};

export default function CustomerStatusBadge({ status }) {
  if (!status) return null;
  const cfg = CUSTOMER_STATUS_MAP[status];
  if (!cfg) return null;
  return (
    <span
      data-testid={`customer-status-badge-${status}`}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-widest border"
      style={{
        color: cfg.color,
        borderColor: `${cfg.color}55`,
        backgroundColor: `${cfg.color}1A`,
      }}
    >
      <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ backgroundColor: cfg.color }} />
      {cfg.label}
    </span>
  );
}
